<section
    class="tw-px-[28px] tw-py-[40px] md:tw-px-[80px] md:tw-py-[50px] tw-bg-[#F8F9FE] tw-flex tw-flex-col tw-gap-[25px] md:tw-gap-[30px]"
>
    <div class="tw-flex tw-flex-col tw-gap-[6px] md:tw-gap-[10px]">
        <span
            class="tw-text-[22px] md:tw-text-[28px] tw-font-bold tw-text-[#0F3172]"
            >{{ 'AWARDS.SECTION.TITLE' | translate }}</span
        >
        <span class="tw-text-[14px] tw-font-normal tw-leading-[18px]"
            >{{ 'AWARDS.SECTION.DESCRIPTION' | translate }}</span
        >
    </div>
    <div
        class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 lg:tw-grid-cols-4 xl:tw-grid-cols-4 tw-gap-[20px] md:tw-gap-[23px] lg:tw-gap-[24px]"
    >
        <app-award-cards
            *ngFor="let award of awards"
            [award]="award"
        ></app-award-cards>
    </div>

    <!-- View More Button -->
    <div class="tw-flex tw-justify-center" *ngIf="hasMoreAwards">
        <button
            (click)="viewMore()"
            class="tw-px-[24px] tw-py-[12px] tw-justify-center tw-items-center tw-font-bold tw-flex tw-flex-row tw-gap-[10px] tw-bg-[#FFF] tw-border-[2px] tw-border-[#003A70] tw-rounded-[30px] tw-text-[14px] tw-text-[#003A70] tw-transition-colors tw-duration-200"
        >
            <span>{{ 'AWARDS.VIEW_MORE' | translate }}</span>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#003A70"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
        </button>
    </div>
</section>
